import { getApolloClient } from '../lib/getApolloClient';
import { GET_TEMPLATE_FOR_TENANT } from './template.gql';

const fetchTemplate = async (tenantId: string) => {
  try {
    const { data } = await getApolloClient().query({
      query: GET_TEMPLATE_FOR_TENANT,
      variables: { id: tenantId },
    });
    return data.templateForTenant;
  } catch (error) {
    console.error('Error fetching template:', error);
    return null;
  }
};

export const templateActions = {
  fetchTemplate,
};
